import { render, staticRenderFns } from "./running.vue?vue&type=template&id=638313da&scoped=true&"
import script from "./running.vue?vue&type=script&lang=js&"
export * from "./running.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638313da",
  null
  
)

export default component.exports